// function
import axios from "axios";

export function encodeFormData(data){
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
}

export function submitFormData(
  formCarryURL,
  submitData,
  successFunction = function () {},
  errorFunction = function () {},
  fatalErrorFunction = function () {},
) {
      axios.post(
          formCarryURL, 
          submitData,
          {headers: {"Accept": "application/json"}}
          )
          .then(function (response) {
            const { data } = response;
      
            if(data.status === "success"){
                // handle success
                successFunction();
            }
            else{
                // handle formcarry error
                errorFunction();
            }
          })
          .catch(function (error) {
            // handle network error
            fatalErrorFunction();
          });
}